import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=2096c942&scoped=true&"
import script from "./SettingsHeader.vue?vue&type=script&lang=ts&"
export * from "./SettingsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&id=2096c942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096c942",
  null
  
)

export default component.exports